import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { AUTH_STATE } from '../tokens/auth-state.token';
import { GET_USER_STATUS } from '../tokens/user-status.token';
import { computeEffectiveStatus } from '../models/user-status.model';
import { foreignRoleRedirect } from './role-areas';

/**
 * Guards /bookings: requires an authenticated approved socio.
 * - Anonymous users → /
 * - Managers → /manager/bookings
 * - Socios with any status other than "approved" → /home
 * - Approved socios → allow
 */
export const bookingsGuard: CanActivateFn = () => {
  const authState$ = inject(AUTH_STATE);
  const getUserStatus = inject(GET_USER_STATUS);
  const router = inject(Router);

  return authState$.pipe(
    take(1),
    switchMap((user) => {
      if (!user) return [router.createUrlTree(['/'])];
      return getUserStatus(user.uid).pipe(
        map((status) => {
          if (!status) return router.createUrlTree(['/']);
          const away = foreignRoleRedirect(router, status.role, ['socio'], {
            manager: '/manager/bookings',
          });
          if (away) return away;
          const effective = computeEffectiveStatus(
            status.registrationStatus,
            user.emailVerified,
          );
          if (effective !== 'approved') {
            return router.createUrlTree(['/home']);
          }
          return true;
        }),
      );
    }),
  );
};
